export const Types = {
    GET_SEGMENT_LIST: "GET_SEGMENT_LIST",
    OPEN_ADD_SEGMENT_MODAL: "OPEN_ADD_SEGMENT_MODAL",
    ADD_SEGMENT: "ADD_PK4SEGMENT",
    GET_EDIT_SEGMENT: "GET_EDIT_SEGMENT",
    UPDATE_SEGMENT: "UPDATE_SEGMENT",
    CLEAR_EDIT_SEGMENT_STATES: "CLEAR_EDIT_SEGMENT_STATES",
  };
